/* eslint-disable no-useless-escape */
class EscapeSymbol {
  /**
     * 半角記号を全角記号へ
     */
  static escapeSymbol(str: string): string {
    return str
      .replace(/\'/g, '’')
      .replace(/\"/g, '”')
      .replace(/\</g, '＜')
      .replace(/\>/g, '＞')
      .replace(/\//g, '／')
      .replace(/\\/g, '＼')
      .replace(/\?/g, '？')
      .replace(/\{/g, '｛')
      .replace(/\}/g, '｝')
      .replace(/\,/g, '，')
      .replace(/\./g, '．')
      .replace(/\(/g, '（')
      .replace(/\)/g, '）')
      .replace(/\-/g, 'ー')
      .replace(/\#/g, '＃')
      .replace(/\!/g, '！')
      .replace(/\$/g, '＄')
      .replace(/\%/g, '％')
      .replace(/\&/g, '＆')
      .replace(/\@/g, '＠')
      .replace(/\=/g, '＝')
      .replace(/\~/g, '〜')
      .replace(/\|/g, '｜')
      .replace(/\[/g, '［')
      .replace(/\]/g, '］')
      .replace(/\+/g, '＋')
      .replace(/\*/g, '＊')
      .replace(/\:/g, '：')
      .replace(/\;/g, '；')
      .replace(/\`/g, '｀');
  }

  /**
     * unescape
     * @param str 文字列
     */
  static unescapeXML(str: string): string {
    return str.replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"')
      .replace(/&apos;/g, "'");
  }
}
export default EscapeSymbol;
